import { InferType, string } from 'yup';

import { ROLE_TYPES_KEYS, ROLE_TYPES_REGEX } from '...data/members/constants';

export const roleSchema = string<ROLE_TYPES_KEYS>().matches(ROLE_TYPES_REGEX).required();

export type Role = InferType<typeof roleSchema>;
